import Vue from "vue";
import Vuex from "vuex";

import location from "./modules/location";
import jobReadiness from "./modules/jobreadiness"
import presence from "./modules/presence"
import presence_detail from "./modules/presence_detail"
import running_text from "./modules/running_text";
import restricted_area from "./modules/restricted_area";
import user from "./modules/user";
import mustering from "./modules/mustering";
import sick_leave from "./modules/sick_leave";
import wake_up_call from "./modules/wake_up_call";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    location,
    jobReadiness,
    presence,
    presence_detail,
    running_text,
    restricted_area,
    user,
    mustering,
    sick_leave,
    wake_up_call
  }
});
